/**
 * @module components/assistant/navRegistry
 * @description 어시스턴트 블록의 내부 네비게이션 entity → 라우트 허용목록 (OD-13/16).
 * LLM/BE가 raw URL·path를 지정하는 것을 금지하고, entity 추상화만 허용한다
 * (open redirect·라우트 위조 차단). 라우트는 name 기반 — 경로 변경에 내성.
 * BE output_guard 의 _NAV_ENTITIES 와 동일 집합을 유지해야 한다.
 */

export const NAV_ENTITIES = ['repair', 'repairHistory', 'settlement', 'consultation', 'dashboard']

/** entity 별 라우트 location 생성기 — 유효하지 않으면 null 반환(네비 불가) */
const REGISTRY = {
  /**
   * 수리 접수 상세 — `:id/:partnerId` 필수 파라미터.
   * partnerId 누락 시 상세 진입이 불가하므로 목록 화면으로 폴백한다.
   */
  repair: (id, p = {}) => {
    if (id == null || id === '') return null
    if (p.partnerId == null || p.partnerId === '') return { name: '접수 현황 관리' }
    return { name: '접수 현황 관리 상세 파라미터', params: { id: String(id), partnerId: String(p.partnerId) } }
  },
  /** 접수 이력 상세 — partnerId 없으면 네비 불가(이력 목록 라우트 부재) */
  repairHistory: (id, p = {}) => {
    if (id == null || id === '' || p.partnerId == null || p.partnerId === '') return null
    return { name: '접수 이력 상세 파라미터', params: { id: String(id), partnerId: String(p.partnerId) } }
  },
  settlement: (id) => (id == null || id === '')
    ? null
    : { name: '정산 확정 상세', params: { settlementId: String(id) } },
  consultation: (id) => (id == null || id === '')
    ? null
    : { name: '상담 이력 상세', params: { consultationId: String(id) } },
  dashboard: () => ({ name: '대시보드' })
}

/**
 * 블록 nav 메타({entity,id,params})를 router location으로 변환한다.
 * 허용목록 외 entity·필수값 누락은 null(no-op) — 호출측에서 비클릭/숨김 처리.
 * @param {object} nav - { entity: string, id?: string|number, params?: object }
 * @returns {object|null} router.push 에 넘길 location 또는 null
 */
export function resolveNav(nav) {
  if (!nav || typeof nav.entity !== 'string') return null
  const build = REGISTRY[nav.entity]
  if (!build) return null
  return build(nav.id, nav.params || {})
}
